/**
 * @module Homepage
 * @description
 */
import Template from '@/templates/Default';

/**
 * @function Page
 * @description
 */
const Page = () => ( <Template title="home" primary={ <h2>Homepage</h2> } /> );

export default Page;
